/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest
 */
export interface FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest
     */
    Receipt: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest
     */
    DeveloperPayload: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest
     */
    Sku: string;
}

/**
 * Check if a given object implements the FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest interface.
 */
export function instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest(value: object): value is FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest {
    if (!('Receipt' in value) || value['Receipt'] === undefined) return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined) return false;
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSON(json: any): FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest {
    return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Receipt': json['Receipt'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
    };
}

export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSON(json: any): FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest {
    return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSONTyped(value?: FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Receipt': value['Receipt'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
    };
}

